import { render, staticRenderFns } from "./MandateConfirmationModal.vue?vue&type=template&id=10192e7a&"
import script from "./MandateConfirmationModal.vue?vue&type=script&lang=ts&"
export * from "./MandateConfirmationModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports